import { render, staticRenderFns } from "./TypographyGlobotipoCorporativaTextosSection.vue?vue&type=template&id=17632118"
import script from "./TypographyGlobotipoCorporativaTextosSection.vue?vue&type=script&lang=ts"
export * from "./TypographyGlobotipoCorporativaTextosSection.vue?vue&type=script&lang=ts"
import style0 from "./TypographyGlobotipoCorporativaTextosSection.vue?vue&type=style&index=0&id=17632118&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports